import {createTextVariant} from './Text.js'

export default createTextVariant('caption', 'Caption')
